import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Reports stats DTO
 */
@CaslSubject(AppSubjectEnum.REPORT)
export class ReportsStatsDto extends BaseStatsDto {
	active!: number;
	archived!: number;
}
